/**
 * Frontend entry point of Color or Image Variation Swatches for WooCommerce Pro.
 *
 * Bundled into assets/js/alg-wc-civs.js by the build script.
 * The base free version code is imported directly from the Composer vendor folder.
 *
 * @version   1.2.3
 * @since     1.2.3
 * @requires  jQuery.js
 */

import '../../vendor/wpfactory/color-or-image-variation-swatches-for-woocommerce/assets/js/alg-wc-civs';
import select2Handler from './modules/select2-handler';
import showOnlyPossibleTermCombinations from './modules/show-only-possible-term-combinations';
import termPointer from './modules/term-pointer';

jQuery(function () {
	var start = function ( alg_wc_civs ) {
		if ( ! alg_wc_civs ) {
			return;
		}

		if ( window.alg_wc_civs_opt && window.alg_wc_civs_opt.use_select2 ) {
			select2Handler( alg_wc_civs );
		}

		if ( window.alg_wc_civs_opt && window.alg_wc_civs_opt.only_valid_term_combinations ) {
			showOnlyPossibleTermCombinations( alg_wc_civs );
		}

		termPointer( alg_wc_civs );
	};

	if ( 'undefined' === typeof window.alg_wc_civs || jQuery.isEmptyObject( window.alg_wc_civs ) ) {
		jQuery( 'body' ).on( 'alg_wc_civs', function ( e ) {
			start( e.obj );
		} );
	} else {
		start( window.alg_wc_civs );
	}
});
